import script from "./RegistrationAndLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationAndLogin.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationAndLogin.vue?vue&type=style&index=0&id=68628891&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68628891"]])

export default __exports__